export default {
  campanhas: {
    snackbars: {
      errors: {
        clone: { mensagem: 'Ocorreu um erro ao duplicar campanha' },
        delete: { mensagem: 'Ocorreu um erro ao deletar campanha' },
        unschedule: { mensagem: 'Ocorreu um erro ao desativar campanha' },
        cancel: { message: 'Ocorreu um erro ao tentar cancelar campanha' },
        finish: { message: 'Ocorreu um erro ao tentar finalizar campanha' },
      },
    },
    confirmations: {
      clone: {
        confirmText: 'Duplicar',
        cancelText: 'Cancelar',
        message: 'Deseja duplicar esta campanha?',
        title: 'Duplicar campanha',
      },
      delete: {
        title: 'Remover campanha',
        message: 'Tem certeza que deseja remover esta campanha?',
        confirmText: 'Remover',
        confirmColor: 'vermelho-d20',
        cancelText: 'Cancelar',
      },
      unschedule: {
        title: 'Desativar campanha',
        message: 'Tem certeza que deseja desativar esta campanha?',
        confirmText: 'Desativar',
        cancelText: 'Cancelar',
      },
      cancel: {
        title: 'Cancelar campanha',
        message: 'Tem certeza que deseja cancelar esta campanha?',
        confirmText: 'Cancelar',
        cancelText: 'Voltar',
      },
      cancel_sendings: {
        title: 'Tem certeza que deseja cancelar os disparos desta campanha?',
        message:
          'Todos os disparos ainda não realizados serão cancelados, e <span class="texto-corrido-destaque">não poderão ser reiniciados</span>. O status da campanha continuará ativo e captando resultados dos disparos realizados até o fim da data de mensuração.',
        confirmText: 'Cancelar Disparos',
        cancelText: 'Voltar',
      },
      finish: {
        title: 'Finalizar campanha',
        message: 'A campanha será movida para o status concluída',
        confirmText: 'Finalizar',
        cancelText: 'Cancelar',
      },
    },
    email_template: {
      fake_date: 'Qua 19/09/2016, 10:58',
      configuracao_do: 'Configuração do ',
      email: {
        section_name: 'e-mail',
        assunto_placeholder: 'SEJA BEM-VINDO',
        remetente_label: 'Remetente',
        remetenteName_label: 'Nome do remetente',
        assunto_label: 'Assunto',
        cor_label: 'Cor de fundo',
        // snippet: 'Olá, seja bem-vindo ao clube!',
        // snippet_label: 'Snippet/preheader'
      },
      // versaoWeb: {
      //   section_name: 'Configuração da versão Web',
      //   texto_placeholder: 'Clique aqui para ver a versão Web',
      //   link_placeholder: 'http://exemplo.com',
      //   texto_label: 'Texto',
      //   link_label: 'Link'
      // },
      titulo: {
        section_name: 'título',
        required_image_size: '192px por 192px',
        texto_placeholder: 'Olá, seja bem-vindo ao clube!',
        texto_label: 'Texto',
        logo_label: 'Logo',
      },
      corpoEmail: {
        section_name: 'corpo do e-mail',
        required_image_size: '192px por 192px',
        image_label: 'Imagem de corpo',
      },
      rodape: {
        section_name: 'rodapé',
        nome_placeholder: 'Nome do supermercado',
        endereco_placeholder: 'Av. Dep. Heitor Alencar Furtado, 5000',
        cidade_placeholder: 'Curitiba',
        estado_placeholder: 'PR',
        cep_placeholder: '82001-001',
        texto_placeholder: 'Você está recebendo esse e-mail porque se cadastrou em nosso clube. Para se descadastrar da lista de e-mail',
        clique_aqui: 'clique aqui',
        link_placeholder: 'http://link-de-saida.com/',
        facebook_placeholder: 'http://facebook.com/mercafacil',
        instagram_placeholder: 'http://instagram.com/mercafacil',
        linkedin_placeholder: 'http://linkedin.com/company/mercafacil',
        nome_label: 'Nome',
        endereco_label: 'Endereço',
        cidade_label: 'Cidade',
        estado_label: 'Estado',
        cep_label: 'CEP',
        texto_label: 'Texto',
        link_label: 'Link de descadastramento',
        link_help_text: 'Fale com seu cliente, lembre-o de porque ele está recebendo este e-mail',
        social_help_text: 'Adicione suas redes sociais',
      },
    },
    tooltips: {
      cancel_sendings: {
        out_of_date: 'Campanha não pode ser cancelada pois a mensagem já foi enviada',
        already_canceled: 'Campanha já foi cancelada',
      },
    },
    abrir_mensagem: 'Abrir mensagem',
    adicione_segmento_para_criar: 'Adicione pelo menos um segmento para ativar a campanha.',
    alterar: 'Alterar',
    ativar: 'Ativar campanha',
    cancelar: 'Cancelar',
    caractere_especial: 'Caractere especial',
    caractere: 'Caractere',
    cliente: 'Cliente',
    clientes_ativados: 'Clientes ativados',
    clientes_que_compraram_tooltip: 'Quantidade de clientes que realizaram pelo menos uma compra no período de mensuração após ter recebido {tipoCampanha}',
    clientes_que_compraram: 'Clientes que compraram',
    clientes: 'Clientes',
    codigo_do_produto: 'Código do produto',
    configuracoes_avancadas: 'Configurações avançadas',
    configuracoes: 'Configurações',
    conteudo: 'Conteúdo',
    creditos: '{creditos} crédito | {creditos} créditos',
    crie_mensagem: 'Crie uma mensagem para esta campanha',
    cupons_campanha: 'Cupons da campanha',
    cupons: 'Cupons',
    custo_em_creditos: 'Custo em créditos',
    custo_estimado: 'Custo estimado',
    custo: 'Custo',
    data: 'Data',
    deletar_campanha: 'Apagar rascunho',
    descricao: 'Descrição',
    destino_notificacao: 'Destino da notificação',
    dias: 'dias',
    disparar_em: 'Disparar em',
    disparos: 'Disparo | Disparos',
    dispositivo: 'Dispositivo',
    duplicar: 'Duplicar',
    editar_campanha: 'Editar campanha',
    editar_template: 'Editar template',
    email: 'E-mail',
    enquanto_houver_creditos: 'A campanha só será enviada se o saldo disponível for maior ou igual ao custo da campanha.',
    envios_tooltip: 'Envios realizados dentro desta campanha',
    envios: 'Resultados por disparo',
    espaco: 'Espaço',
    excluir: 'Excluir campanha',
    exportar_csv: 'Exportar .CSV',
    faturamento_com_produto: 'Faturamento com produto no cupom',
    faturamento_do_produto: 'Faturamento do produto',
    faturamento_tooltip: 'Faturamento dos cupons de clientes impactados',
    faturamento: 'Faturamento',
    fechar: 'Fechar',
    finalizar_em: 'Finalizar em',
    frequencia: 'Frequência',
    fuso_horario: 'Horário de Brasília: (GMT {fusoHorario})',
    historico_tooltip: 'Histórico das mensagens enviadas nesta campanha',
    historico: 'Histórico',
    hora: 'Hora',
    iniciar_em: 'Iniciar em',
    inspecao: 'Inspeção',
    mais_informacoes_1: 'Mensagens podem conter até 160 caracteres por crédito.',
    mais_informacoes_2: 'Com o uso de caracteres especiais (acentuações e cedilhas por exemplo), cada mensagem passa a conter até 70 caracteres por crédito.',
    mais_informacoes_3: 'Mensagens de mais de um crédito consomem caracteres para ligar as partes.',
    mais: 'Mais',
    menos: 'Menos',
    mensagem_excedida: 'mensagem',
    mensagem: 'Mensagem',
    mensagens: 'mensagens',
    mercafacil: 'MERCAFACIL',
    message_help_text: 'Caracteres especiais podem aumentar significativamente o custo de envio.',
    nome_do_produto: 'Nome do produto',
    notificacao_push: 'Notificação por push',
    nova_campanha: 'Nova campanha',
    numero_de_clientes: 'Número de clientes',
    numero_de_cupons: 'Número de cupons',
    numero: 'Número',
    pagina_inicial: 'Página inicial',
    percentual_entrega: '{percentual} de entrega',
    percentual_receberam_mensagem: '{percentual} dos que receberam a mensagem',
    periodo_mensuracao: 'Período de mensuração',
    periodo: 'Período',
    porcentagem_dos_atingidos: '{compraram} de {atingindos} atingidos',
    porcentagem_do_publico_alvo: '{porcentagem}% do público alvo',
    porcentagem_ticket_medio: '{porcentagem}% {variacao} de quem não recebeu',
    prazo: 'Prazo',
    produtos_fazem_parte_campanha: 'Selecione quais produtos vão fazer parte dessa campanha.',
    produtos: 'Produtos',
    publico_alvo: 'Público-alvo',
    quantidade_cupons: '{quantidade} cupons',
    recorrente: 'Recorrente',
    repetir_cada: 'Repetir a cada',
    impacto: 'Impacto',
    resultados_campanha: 'Resultados da campanha',
    resultados_destaque: 'Resultados do destaque',
    resultados_por_produto_tooltip: 'Resultados por produto da campanha',
    resultados_por_produto: 'Resultados por produto',
    resultados_por_loja: 'Resultados por loja',
    roi_tooltip: 'Faturamento gerado para cada real investido em campanha',
    saldo_atual: 'Saldo atual',
    salvar_alteracoes: 'Salvar alterações',
    salvar_rascunho: 'Salvar rascunho',
    salvar: 'Salvar',
    segmento_ja_criado: 'Selecione quais grupos de pessoas serão impactadas com a sua campanha.',
    sms_enviados: 'SMS enviados',
    sms_enviados_help_text: 'Quantidade de SMS enviados e porcentagem em relação à quantidade de clientes nos segmentos da campanha.',
    sms_recebidos: 'SMS recebidos',
    somente_uma_vez: 'Somente uma vez',
    status: 'Status',
    texto_enviado_por_sms: 'Texto que será enviado por SMS',
    texto_mensagem: 'Texto da mensagem',
    texto_notificacao: 'Texto da notificação',
    ticket_medio_tooltip: 'Valor médio dos cupons de clientes ativos',
    ticket_medio: 'Ticket médio',
    tipo: 'Tipo',
    titulo: 'Título',
    total_cupons_identificados: 'Total de cupons identificados',
    validade_campanha: 'Período de {dia} dia | Período de {dia} dias',
    validade_mensagem_quatro_horas: 'A validade padrão da mensagem na operadora é de 4 horas. Após este período a entrega não será contabilizada',
    validade_total_ofertas_produtos: 'Validade total das ofertas dos produtos',
    variaveis: 'Variável | Variáveis',
    subvariaveis: 'Subvariável | Subvariáveis',
    ver_historico: 'Ver histórico',
    voltar_rascunho: 'Desativar',
    volume_de_vendas: 'Volume de vendas na campanha',
    chatbot: {
      avalicao: 'Sem avaliações | {quantidade} avaliação | {quantidade} avaliações',
    },
    gestao_de_ofertas: {
      results: {
        uplift: {
          tooltips: {
            revenue:
              'Comparativo do faturamento total dos produtos entre o período da oferta e período anterior. Todas as vendas nos períodos são contabilizadas, independentemente de ter uma aplicação da oferta.',
            quantity:
              'Comparativo da quantidade vendida dos produtos entre o período da oferta e período anterior. Todas as vendas nos períodos são contabilizadas, independentemente de ter uma aplicação da oferta.',
            coupons:
              'Comparativo da quantidade de cupons com os produtos entre o período da oferta e período anterior. Todas as vendas nos períodos são contabilizadas, independentemente de ter uma aplicação da oferta.',
            consumers:
              'Comparativo da quantidade de consumidores que compraram os produtos entre o período da oferta e período anterior. Todas as vendas nos períodos são contabilizadas, independentemente de ter uma aplicação da oferta.',
          },
        },
      },
    },
  },
}
